import { FunctionComponent } from 'react';
import { Box, IconButton } from '@material-ui/core';
import { gutters } from 'Theme/Variables';
import { IstanbulKartLogo } from 'Components';
import { useWindowDimensions } from 'Hooks';
import { useHistory } from 'react-router';
import { routePath } from 'Navigator/routes';

import './FullPageWrapper.scss';

type FullPageWrapperProps = {
  children: JSX.Element;
};

const FullPageWrapper: FunctionComponent<FullPageWrapperProps> = ({ children }) => {
  const { height } = useWindowDimensions();
  const history = useHistory();

  return (
    <div id="fullPageWrapper" style={{ minHeight: height }}>
      <header>
        <Box paddingY={gutters.large}>
          <IconButton
            aria-label="Ana sayfaya git"
            onClick={() => history.push(routePath.welcome)}
            size="small"
            style={{ borderRadius: 4, padding: 4 }}
          >
            <IstanbulKartLogo />
          </IconButton>
        </Box>
      </header>
      <main id="main-content" style={{ display: 'contents' }}>
        {children}
      </main>
    </div>
  );
};

export default FullPageWrapper;
